(function () {
  if (window.__sdCartRecos) { window.__sdCartRecos.refresh(); return; }

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PROT = [47319584669730, 47319584702498];
  var LV_KEY = 'sd_last_product';
  var lastSeed = null, cache = null, t = null;

  var EMPTY_HEADS = [
    'Did you check these out?',
    'Picked for you',
    'Start your drop here',
    'Fresh off the rack'
  ];

  function protIds() { return (window.SDProtection && window.SDProtection.variants) || PROT; }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function mounts() { return document.querySelectorAll('[data-sd-recos]'); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents, cur) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function sized(url) { return url ? url.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_320x$1$2') : ''; }

  /* remember the last product page visited, so an empty cart still has a seed */
  function noteLastViewed() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    try { localStorage.setItem(LV_KEY, m[1]); } catch (e) {}
  }
  function lastViewedId() {
    var h = null;
    try { h = localStorage.getItem(LV_KEY); } catch (e) {}
    if (!h) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return p ? p.id : null; })
      .catch(function () { return null; });
  }

  /* /recommendations and /collections return different shapes — flatten both */
  function norm(p) {
    var vs = (p.variants || []).map(function (v) {
      return {
        id: v.id,
        available: v.available !== false,
        price: typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price
      };
    });
    var img = p.featured_image
      || (p.images && p.images[0] && (p.images[0].src || p.images[0]))
      || '';
    var price = typeof p.price === 'number'
      ? p.price
      : (vs.length ? Math.min.apply(null, vs.map(function (v) { return v.price || 0; })) : 0);
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      url: p.url || ('/products/' + p.handle),
      image: img,
      price: price,
      variants: vs
    };
  }

  function pickSeed(cart) {
    var ids = protIds();
    var best = null, bestPrice = -1, inCart = [];
    cart.items.forEach(function (it) {
      if (ids.indexOf(it.variant_id) !== -1) return;
      inCart.push(it.product_id);
      if (it.line_price > bestPrice) { bestPrice = it.line_price; best = it.product_id; }
    });
    return { seed: best, ids: inCart };
  }

  function fetchRecs(seed) {
    var base = '/recommendations/products.json?limit=10&product_id=' + seed + '&intent=';
    return fetch(base + 'complementary', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.products && d.products.length) return d.products;
        return fetch(base + 'related', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (d2) { return (d2 && d2.products) || []; });
      })
      .catch(function () { return []; });
  }

  /* empty cart, nothing viewed yet — fall back to the first collection chip */
  function collectionFallback() {
    var chip = document.querySelector('[data-sd-recos] ~ * .empty-collections-item, .empty-collections-item');
    var handle = 'all';
    if (chip) {
      var m = (chip.getAttribute('href') || '').match(/\/collections\/([^\/?#]+)/);
      if (m) handle = m[1];
    }
    return fetch('/collections/' + handle + '/products.json?limit=12', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  /* Add button hands off to the theme's own quick-add sheet via [data-sd-qa]. */
  function addBtn(p) {
    var avail = p.variants.filter(function (v) { return v.available; });
    var title = esc(p.title);
    if (!avail.length) return '<span class="sd-rec__add sd-rec__add--out" aria-hidden="true">&minus;</span>';
    if (p.variants.length === 1) {
      return '<button type="button" class="sd-rec__add"'
           + ' data-sd-qa="' + esc(p.handle) + '"'
           + ' data-sd-qa-single="true"'
           + ' data-sd-qa-variant="' + p.variants[0].id + '"'
           + ' aria-label="Add ' + title + ' to bag">+</button>';
    }
    return '<button type="button" class="sd-rec__add"'
         + ' data-sd-qa="' + esc(p.handle) + '"'
         + ' aria-label="Choose size and add ' + title + '">+</button>';
  }

  function cardHTML(p, cur) {
    var imgTag = p.image ? '<img src="' + sized(p.image) + '" alt="" loading="lazy">' : '';
    return '<div class="sd-rec">' +
        '<a class="sd-rec__img" href="' + esc(p.url) + '">' + imgTag + '</a>' +
        '<div class="sd-rec__meta">' +
          '<a class="sd-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="sd-rec__price">' + money(p.price, cur) + '</span>' +
        '</div>' + addBtn(p) +
      '</div>';
  }

  function paint(products, cur, empty) {
    var list = mounts();
    if (!list.length) return;
    if (!products || !products.length) {
      list.forEach(function (m) { m.innerHTML = ''; m.hidden = true; });
      return;
    }
    var head = empty
      ? EMPTY_HEADS[Math.floor(Math.random() * EMPTY_HEADS.length)]
      : 'Complete your drop';

    var cards = products.slice(0, 10).map(function (p) { return cardHTML(p, cur); }).join('');
    var html = '<div class="sd-recs' + (empty ? ' sd-recs--empty' : '') + '">' +
        '<p class="sd-recs__head">' + esc(head) + '</p>' +
        '<div class="sd-recs__rail">' + cards + '</div>' +
      '</div>';

    list.forEach(function (m) {
      m.hidden = false;
      m.innerHTML = html;
      if (!REDUCED) {
        requestAnimationFrame(function () {
          var els = m.querySelectorAll('.sd-rec');
          for (var i = 0; i < els.length; i++) {
            els[i].style.setProperty('--d', (i * 55) + 'ms');
            els[i].classList.add('sd-rec--in');
          }
        });
      }
    });
  }

  function renderSeed(seed, inCart, cur, empty) {
    var show = function (raw) {
      var out = raw.map(norm).filter(function (p) { return inCart.indexOf(p.id) === -1; });
      paint(out, cur, empty);
    };
    if (seed === lastSeed && cache) { show(cache); return; }
    fetchRecs(seed).then(function (raw) {
      lastSeed = seed;
      cache = raw;
      if (!raw.length && empty) { collectionFallback().then(show); return; }
      show(raw);
    });
  }

  function build() {
    if (!mounts().length) return;
    getCart().then(function (cart) {
      var cur = cart.currency || 'USD';
      var s = pickSeed(cart);

      if (s.seed) { renderSeed(s.seed, s.ids, cur, false); return; }

      // empty cart — seed from the last product viewed, else a collection
      lastViewedId().then(function (id) {
        if (id) renderSeed(id, [], cur, true);
        else collectionFallback().then(function (raw) { paint(raw.map(norm), cur, true); });
      });
    }).catch(function () {});
  }

  function schedule() { clearTimeout(t); t = setTimeout(build, 140); }

  ['sd:cart-changed', 'sd:cart:updated', 'sd:cart:added', 'cart:updated', 'cart:refresh', 'sd:cart-drawer-open']
    .forEach(function (ev) { document.addEventListener(ev, schedule); });
  window.addEventListener('pageshow', schedule);

  var css = document.createElement('style');
  css.textContent = [
    '[data-sd-recos][hidden]{display:none;}',
    '.sd-recs{margin:10px 0 16px;}',
    '.sd-recs--empty{margin-top:4px;}',
    '.sd-recs__head{margin:0 0 10px;font-family:var(--sd-mono,ui-monospace,monospace);font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:var(--sd-ash,#8a857c);}',
    '.sd-recs--empty .sd-recs__head{color:var(--sd-bone,#EDE7DA);}',
    '.sd-recs__rail{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:4px;scrollbar-width:none;}',
    '.sd-recs__rail::-webkit-scrollbar{display:none;}',
    '.sd-rec{position:relative;flex:0 0 130px;scroll-snap-align:start;border:1px solid rgba(237,231,218,.1);border-radius:12px;overflow:hidden;background:rgba(237,231,218,.02);}',
    '.sd-rec--in{animation:sd-rec-in .6s cubic-bezier(.16,1,.3,1) both;animation-delay:var(--d,0ms);}',
    '@keyframes sd-rec-in{from{opacity:0;transform:translateY(10px) scale(.97);}to{opacity:1;transform:none;}}',
    '.sd-rec__img{display:block;aspect-ratio:4/5;background:#fff;}',
    '.sd-rec__img img{width:100%;height:100%;object-fit:cover;transition:transform .6s cubic-bezier(.16,1,.3,1);}',
    '@media(hover:hover){.sd-rec:hover .sd-rec__img img{transform:scale(1.06);}}',
    '.sd-rec__meta{padding:8px 9px 10px;display:flex;flex-direction:column;gap:3px;}',
    '.sd-rec__title{font-size:11px;line-height:1.25;color:var(--sd-bone,#EDE7DA);text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}',
    '.sd-rec__price{font-family:var(--sd-mono,ui-monospace,monospace);font-size:11px;color:var(--sd-ash,#a49f96);}',
    '.sd-rec__add{position:absolute;top:8px;right:8px;width:30px;height:30px;display:grid;place-items:center;border:0;border-radius:50%;cursor:pointer;background:var(--sd-blood,#B4141B);color:var(--sd-bone,#EDE7DA);font-size:17px;line-height:1;text-decoration:none;box-shadow:0 4px 12px -4px rgba(180,20,27,.9);transition:transform .3s cubic-bezier(.34,1.56,.64,1),background-color .25s ease;}',
    '.sd-rec__add:active{transform:scale(.85);}',
    '.sd-rec__add.is-busy{opacity:.6;pointer-events:none;}',
    '.sd-rec__add.is-done{background:#1a7f37;}',
    '.sd-rec__add--out{background:rgba(237,231,218,.12);color:var(--sd-ash,#8a857c);box-shadow:none;cursor:default;}',
    '@media (prefers-reduced-motion: reduce){.sd-rec--in{animation:none;}.sd-rec__img img,.sd-rec__add{transition:none;}}'
  ].join('');
  document.head.appendChild(css);

  noteLastViewed();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  window.__sdCartRecos = { refresh: schedule };
})();